



























import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import { InjectReactive } from 'vue-property-decorator'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import { PreferenceResourceType } from '@/modules/preferences/models/preference-resource.model'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import { AdminPreferencesServices } from '@/modules/preferences/services/admin-preferences.service'

@Component({
  components: {
    BaseSelect,
    TesTr,
    TesTd,
    TextEllipsis
  }
})
export default class AdminPreferencesTableRow extends mixins<TesTableRow>(TesTableRow) {
  constructor(
    private readonly adminPreferencesServices: AdminPreferencesServices
  ) {
    super()
  }

  @InjectReactive()
  notifications!: PreferenceResourceType
  private departmentsSelectLabel: string = 'دپارتمان ها'

  get options() {
    return this.notifications.departments.map((department) => ({
      label: department.title,
      value: department.id.toString()
    }))
  }

  save() {
    // this.adminPreferencesServices.update(this.notifications.data)
  }

}
